// Analytics e tracking de buscas

export function trackSearch(query: string, filters: any): void {
  console.log('📊 Search tracked:', { query, filters, timestamp: new Date().toISOString() });
  
  // Aqui você pode integrar com Google Analytics, Mixpanel, etc.
  // if (window.gtag) {
  //   window.gtag('event', 'search', { search_term: query, ...filters });
  // }
}

export function trackPageView(page: string): void {
  console.log('📄 Page view:', page);
}

export function trackEvent(category: string, action: string, label?: string): void {
  console.log('🎯 Event:', { category, action, label });
}
